import React from 'react';
import { connect } from 'react-redux';
import {
  getGroups,
  getMaterialWithLaserParameters,
  getSelectedSection,
  getSelectedShield,
  getMatrix,
  isWebComponentEnvironment
} from '@/helpers';
import {
  splitSection,
  addSectionAngle,
  addSectionMirror,
  mergeMatrixCells,
  splitMatrixCell,
  appendMatrixSeparator,
  appendMatrixRow,
  appendMatrixCell,
  onMatrixCellWidthChangeClb,
  setIsShowMatrixBorderThunk,
  addCustomFontColor,
  setGridDisplayState,
  setCmmeStates,
  setLaserOutputQualityValueToSectionThunk,
  setGridWidth,
  updateSelectedSectionsProps,
  updateSectionShapeProps,
  setShowInsertModalState,
  addNewSections,
} from '@/actions';
import SideBar from '@/components/SideBar';
import TextFieldMatrix from '@/models/TextFieldMatrix';

const OptionPanel = props => {
  return <SideBar {...props} />;
};

const mapStateToProps = state => {
  return {
    pages: state.core.pages,
    sectionsSelection: state.core.sectionsSelection,
    shieldsSelection: state.core.shieldsSelection,
    pagesSelection: state.core.pagesSelection,
    userSizeUnit: state.core.userSizeUnit,
    customFontColors: state.core.customFontColors,
    isGridDisplayed: state.core.isGridDisplayed,
    groupSelectionType: state.core.groupSelectionType,
    isShowInsertModal: state.core.isShowInsertModal,
    cmmeStates: state.core.cmmeStates,
    gridWidth: state.core.gridWidth,
    preselectedPrinter: state.core.preselectedPrinter,
    printerList: state.core.printerList,
  };
};

const mapDispatchToProps = dispatch => ({
  splitSectionVertical: () => dispatch(splitSection('vertical')),
  splitSectionHorizontal: () => dispatch(splitSection('horizontal')),
  addNewSections: () => dispatch(addNewSections()),
  addSectionAngle: dAngle => dispatch(addSectionAngle(dAngle, true)),
  addSectionMirror: coord => dispatch(addSectionMirror(coord, true)),
  mergeMatrixCells: () => dispatch(mergeMatrixCells()),
  splitMatrixCell: () => dispatch(splitMatrixCell()),
  appendMatrixSeparator: type => dispatch(appendMatrixSeparator(type)),
  appendMatrixRow: type => dispatch(appendMatrixRow(type)),
  appendMatrixCell: (position, type) => dispatch(appendMatrixCell(position, type)),
  setIsShowMatrixBorderThunk: shield => dispatch(setIsShowMatrixBorderThunk(shield)),
  addCustomFontColor: color => dispatch(addCustomFontColor(color)),
  setGridDisplayState: state => dispatch(setGridDisplayState(state)),
  setCmmeStates: state => dispatch(setCmmeStates(state)),
  setLaserOutputQualityValueToSectionThunk: (section, value) => dispatch(setLaserOutputQualityValueToSectionThunk(section, value)),
  setGridWidth: width => dispatch(setGridWidth(width)),
  updateSelectedSectionsProps: (data, isUndoable) => dispatch(updateSelectedSectionsProps(data, isUndoable)),
  onMatrixCellWidthChangeClb: width => dispatch(onMatrixCellWidthChangeClb(width)),
  updateSectionShapeProps: props => dispatch(updateSectionShapeProps(props)),
  setShowInsertModalState: value => dispatch(setShowInsertModalState(value)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    pages,
    sectionsSelection,
    shieldsSelection,
    pagesSelection,
    userSizeUnit,
    customFontColors,
    isGridDisplayed,
    groupSelectionType,
    isShowInsertModal,
    cmmeStates,
    gridWidth,
    preselectedPrinter,
    printerList,
  } = stateProps;
  const {
    splitSectionVertical,
    splitSectionHorizontal,
    addNewSections,
    addSectionAngle,
    addSectionMirror,
    mergeMatrixCells,
    splitMatrixCell,
    appendMatrixSeparator,
    appendMatrixRow,
    appendMatrixCell,
    setIsShowMatrixBorderThunk,
    addCustomFontColor,
    setGridDisplayState,
    setCmmeStates,
    setLaserOutputQualityValueToSectionThunk,
    setGridWidth,
    updateSelectedSectionsProps,
    onMatrixCellWidthChangeClb,
    updateSectionShapeProps,
    setShowInsertModalState,
  } = dispatchProps;
  const selectedSection = getSelectedSection({ sectionsSelection, pages });
  const selectedShield = getSelectedShield({ pages, shieldsSelection, selectedSection });
  const selectedPage = pagesSelection.length ? pages[pagesSelection[0]] : null;
  const sections = selectedPage?.sections ? selectedPage.sections : {};
  const layouts = selectedPage?.layouts ? selectedPage.layouts : {};
  const _isMatrix = getMatrix({ pages, selectedShield, selectedSection, sections, layouts });
  const hasPages = Object.keys(pages).length > 0;
  const materialWithLaserParameters = getMaterialWithLaserParameters();
  const isMaterialWithLaserParameters = !!hasPages && materialWithLaserParameters.available && materialWithLaserParameters.$3;
  const isMatrix = selectedShield?.isMatrix || _isMatrix || false;
  const isFlipVerticalAvailable = !isWebComponentEnvironment();
  const matrixTemplate = isMatrix ? TextFieldMatrix.buildTemplate({ shield: selectedShield, sections }) : null;
  const disableMatrixCellWidth = matrixTemplate?.totalRowsNumber > 1;

  return {
    pages,
    pagesGroups: getGroups(pages),
    groupSelectionType,
    userSizeUnit,
    customFontColors,
    addCustomFontColor,
    isGridDisplayed,
    isShowInsertModal,
    hasPages,
    areShieldsSelected: !!Object.keys(shieldsSelection).length,
    areSectionsSelected: Boolean(Object.keys(sectionsSelection).length),
    isMaterialWithLaserParameters,
    selectedSection,
    isMatrix,
    cmmeStates,
    setCmmeStates,
    sectionsSelection,
    sections,
    gridWidth,
    updateSelectedSectionsProps,
    updateSectionShapeProps,
    addSectionAngle,
    addSectionMirror,
    areShieldControlsDisabled: !selectedShield,
    areSectionControlsDisabled: !selectedSection,
    selectedShield,
    splitSectionVertical,
    splitSectionHorizontal,
    addNewSections,
    setGridDisplayState,
    setLaserOutputQualityValueToSectionThunk,
    setGridWidth,
    mergeMatrixCells,
    splitMatrixCell,
    appendMatrixCell,
    appendMatrixRow,
    appendMatrixSeparator,
    setIsShowMatrixBorderThunk,
    preselectedPrinter,
    printerList,
    setShowInsertModalState,
    isFlipVerticalAvailable,
    onMatrixCellWidthChangeClb,
    disableMatrixCellWidth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(OptionPanel);
